
import { DSGSubscribeParameter,subscribeToList, SubscribeToListApiParameter } from "@DSG/Services/DSGEmailService";
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

 
 type SubscribeParameter = {
   // emailAddress: string;
    onError?: (error: string) => void;
} & DSGSubscribeParameter &
    HasOnSuccess<boolean>;

 type HandlerType = ApiHandler<SubscribeParameter, boolean>;


export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    const result = await subscribeToList(props.apiParameter);
    if (result) {
        props.apiResult = result;
 } else {
    props.apiResult = false;
 }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const dsgSubscribeHandler = createHandlerChainRunner(chain, "DSGSubscribeHandler");
export default dsgSubscribeHandler;
